import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import _keys from 'lodash/keys';
import { RenderField, RenderTextareaField, RenderSubmitButton, RenderDatePicker, RenderHiddenField, RenderGeosuggest, RenderTimePicker, RenderToggleField, RenderDropdownSelect } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import AddressFields from '../../../common/form/AddressFields';
import EventTypes from '../../events/util/EventTypes';
import Loader from '../../../common/ui/Loader';
import SortableMealOptions from './SortableMealOptions/SortableMealOptions';
import SortableRsvpQuestions from './SortableRsvpQuestions/SortableRsvpQuestions';

// Styles
import './EventForm.less';

class EventForm extends Component {
  constructor(props) {
    super(props);

    this.toggleAddress = this.toggleAddress.bind(this);
    this.switchCommonQs = this.switchCommonQs.bind(this);
    this.switchAttireOs = this.switchAttireOs.bind(this);
    this.selectQuestion = this.selectQuestion.bind(this);
    this.selectAttire = this.selectAttire.bind(this);
    this.resetAddress = this.resetAddress.bind(this);
    this.prefillEventName = this.prefillEventName.bind(this);

    this.state = {
      autoAddress: true,
      commonQs: false,
      attireOs: false,
    };
  }

  componentWillMount() {
    const { initialValues } = this.props;
    if (initialValues.venueName || initialValues.city || initialValues.state_province || initialValues.address_1 || initialValues.address_2) {
      this.setState({
        autoAddress: false
      });
    }
  }

  componentDidMount() {
    const { getRsvpSuggestions, getSuggestedAttireOptions } = this.props;
    getRsvpSuggestions();
    getSuggestedAttireOptions();
  }

  componentWillReceiveProps(nextProps) {
    const { address, handleAddress } = this.props;
    if (_keys(nextProps.address).length > 0 && nextProps.address !== address && !nextProps.address.busy) {
      handleAddress(nextProps.address);
    }
  }

  componentWillUnmount() {
    const { onSelectEvent } = this.props;
    onSelectEvent(null);
    this.resetAddress();
  }

  getEventNameByType(type) {
    const eventType = EventTypes.find(obj => obj.value === type);
    return eventType ? eventType.title : null;
  }

  toggleAddress() {
    this.setState(state => ({ autoAddress: !state.autoAddress }));
  }

  resetAddress() {
    const { address, onResetAddress } = this.props;
    if (address.google_place_id) {
      onResetAddress(address);
      this.setState({
        autoAddress: true
      });
    }
  }

  switchCommonQs() {
    const { onToggleCommonQs } = this.props;
    this.setState(state => ({ commonQs: !state.commonQs }));
    if (onToggleCommonQs) {
      onToggleCommonQs();
    }
  }

  switchAttireOs() {
    const { onToggleAttireOs } = this.props;
    this.setState(state => ({ attireOs: !state.attireOs }));
    if (onToggleAttireOs) {
      onToggleAttireOs();
    }
  }

  selectQuestion(question) {
    const { setQuestion, onToggleCommonQs } = this.props;
    if (question) {
      setQuestion(question);
    }
    if (onToggleCommonQs) {
      onToggleCommonQs();
    }
    this.setState({ commonQs: false });
  }

  selectAttire(attire) {
    const { setSelectedAttire, onToggleAttireOs } = this.props;
    if (attire) {
      setSelectedAttire(attire);
    }
    if (onToggleAttireOs) {
      onToggleAttireOs();
    }
    this.setState({ attireOs: false });
  }

  prefillEventName(type, name) {
    const { setEventName } = this.props;
    const eventName = this.getEventNameByType(type);

    if (!name && eventName) setEventName(eventName);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      valid,
      getSuggestion,
      address,
      rsvpSuggestions,
      suggestedAttireOptions,
      onResetAddressSearch,
      forMultipleEventsMigration,
      mealOptionCounts,
      rsvpQuestionCounts,
      onDeleteRsvpQuestion,
      onDeleteMealOption,
      onReorder,
      formValues
    } = this.props;
    const { commonQs, attireOs } = this.state;
    return (
      <div className="event-form-container">
        {!commonQs && !attireOs && (
          <form onSubmit={handleSubmit} id="event-form" className="event-form" noValidate>
            <div className="row">
              <div className="col-sm-4">
                <Field
                  component={RenderDropdownSelect}
                  name="type"
                  options={EventTypes}
                  id="event-type-2"
                  label="Event Type"
                  required
                  validate={Validations.REQUIRED}
                  onChange={(_e, newValue) => this.prefillEventName(newValue, formValues.name)}
                />
              </div>
              <div className="col-sm-8">
                <Field
                  component={RenderField}
                  name="name"
                  label="Event Name"
                  type="text"
                  id="event-name"
                  placeholder="Our Ceremony"
                  required
                  maxChars={100}
                  validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <Field
                  component={RenderDatePicker}
                  name="date"
                  label="Date"
                  id="event-date"
                  datePickerOptions={{ disabledDays: { before: new Date() } }}
                  required
                  validate={[Validations.REQUIRED, Validations.DATE, Validations.DATE_AFTER_NOW]}
                />
              </div>
              <div className="col-sm-3">
                <Field
                  component={RenderTimePicker}
                  name="start_at"
                  id="event-start-time"
                  label="Start Time"
                  required
                  validate={Validations.REQUIRED}
                />
              </div>
              <div className="col-sm-3">
                <Field
                  component={RenderTimePicker}
                  name="end_at"
                  id="event-end-time"
                  label="End Time"
                />
              </div>
            </div>
            {this.state.autoAddress && !address.busy && (
              <div className="form-group venue-name">
                <Field
                  name="venue_name"
                  label={<span>Event Location <span className="text-button margin-left" style={{ paddingTop: '5px' }} onClick={this.toggleAddress}>Or Enter Address Manually &rsaquo;</span></span>}
                  id="event-venue-address"
                  placeholder="Brooklyn Winery"
                  validate={Validations.MAX_LENGTH_50}
                  maxChars={50}
                  component={RenderGeosuggest}
                  onSuggestSelect={(suggestion) => {
                    if (!suggestion) {
                      return;
                    }
                    getSuggestion(suggestion)
                      .then(() => this.toggleAddress())
                      .catch(() => onResetAddressSearch());
                  }}
                  inputClassName="form-control"
                />
              </div>
            )}
            {!this.state.autoAddress && !address.busy && (
              <div className="event-address">
                <div className="form-group venue-name">
                  <Field
                    component={RenderField}
                    type="text"
                    label="Venue Name"
                    id="event-venue-name"
                    name="venue_name"
                    validate={Validations.MAX_LENGTH_50}
                    maxChars={50}
                    hideFormGroup
                  />
                  {address.google_place_id ? (
                    <span className="pull-right text-button" style={{ paddingTop: '5px' }} onClick={this.resetAddress}>Reset Search</span>
                  ) : (
                    <span className="pull-right text-button" style={{ paddingTop: '5px' }} onClick={this.toggleAddress}>Search For Location</span>
                  )}
                </div>
                <AddressFields selector="eventForm" minimal optional />
              </div>
            )}
            {address.busy && (
              <Loader />
            )}
            <Field
              component={RenderField}
              type="text"
              maxChars={400}
              validate={Validations.MAX_LENGTH_400}
              name="attire"
              placeholder="The attire is black tie optional. The grass can be a little soft, so you might want to rethink stilettos!"
              id="event-attire"
              label={<span>Attire<span className="text-button margin-left" onClick={this.switchAttireOs}>See Common Attire Suggestions &rsaquo;</span></span>}
            />
            <Field
              component={RenderHiddenField}
              name="suggested_attire_option_id"
            />
            <Field
              component={RenderTextareaField}
              name="note"
              label="Note to Guests"
              placeholder="Parking is at the back of the venue."
              id="event-note"
              maxChars={1000}
              rows={3}
              validate={Validations.MAX_LENGTH_1000}
            />
            {!forMultipleEventsMigration && (
              <FieldArray
                name="meal_options"
                component={SortableMealOptions}
                label="Ask For Meal Preferences"
                id="meal-options"
                mealOptionCounts={mealOptionCounts}
                onDeleteMealOption={onDeleteMealOption}
                useDragHandle
                lockAxis="y"
                onSortEnd={({ oldIndex, newIndex }) => onReorder('meal_options', oldIndex, newIndex)}
                rerenderOnEveryChange
              />
            )}
            {!forMultipleEventsMigration && (
              <FieldArray
                name="rsvp_questions"
                component={SortableRsvpQuestions}
                label={<span>Ask Other RSVP Questions <span className="text-button margin-left" onClick={this.switchCommonQs}>See Common Rsvp Questions &rsaquo;</span></span>}
                id="rsvp-questions"
                rsvpQuestionCounts={rsvpQuestionCounts}
                onDeleteRsvpQuestion={onDeleteRsvpQuestion}
                useDragHandle
                lockAxis="y"
                onSortEnd={({ oldIndex, newIndex }) => onReorder('rsvp_questions', oldIndex, newIndex)}
                rerenderOnEveryChange
              />
            )}
            {!forMultipleEventsMigration && (
              <div className="website-settings">
                <strong className="form-label website-settings-label">Website Settings</strong>
                <br />
                <Field
                  name="public"
                  component={RenderToggleField}
                  id="is-public"
                  label="Make event public on website"
                  className="website-settings-toggle"
                  tooltip={'Switch the toggle to "Yes" if you want all guests to see this event on your wedding website.'}
                  inline
                  hideFormGroup
                />
                <Field
                  name="collect_rsvps"
                  component={RenderToggleField}
                  id="collect-rsvps"
                  label="Allow guests to RSVP on website"
                  className="website-settings-toggle"
                  tooltip={'Switch the toggle to "Yes" and let invited guests RSVP to an event on your site. Even if it\'s private, guests can RSVP online.'}
                  inline
                  hideFormGroup
                />
              </div>
            )}
            <div className="event-submit-button">
              <RenderSubmitButton pristine={false} valid={valid} disabled={submitting} />
            </div>
          </form>
        )}
        {commonQs && (
          <div className="rsvp-suggestions">
            <span className="text-button back-button" onClick={this.switchCommonQs}>&lsaquo; back</span>
            <ul className="common-faqs list-unstyled">
              {rsvpSuggestions && rsvpSuggestions.map((question, idx) => (
                <li className="common-faq" role="button" onClick={() => this.selectQuestion(question)} key={idx}>
                  {question.question}
                  <div className="center">
                    <span className="text-button pull-right">Select &rsaquo;</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
        {attireOs && (
          <div className="rsvp-suggestions">
            <span className="text-button back-button" onClick={this.switchAttireOs}>&lsaquo; back</span>
            <ul className="common-faqs list-unstyled">
              {suggestedAttireOptions && suggestedAttireOptions.map((attire, idx) => (
                <li className="common-faq" role="button" onClick={() => this.selectAttire(attire)} key={idx}>
                  {attire.attire}
                  <div className="center">
                    <span className="text-button pull-right">Select &rsaquo;</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

EventForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    venue_name: PropTypes.string
  }),
  rsvpSuggestions: PropTypes.arrayOf(PropTypes.shape({})),
  suggestedAttireOptions: PropTypes.arrayOf(PropTypes.shape({})),
  getSuggestion: PropTypes.func,
  getRsvpSuggestions: PropTypes.func,
  getSuggestedAttireOptions: PropTypes.func,
  setQuestion: PropTypes.func,
  setSelectedAttire: PropTypes.func,
  address: PropTypes.shape({
    busy: PropTypes.bool
  }),
  handleAddress: PropTypes.func,
  onResetAddress: PropTypes.func,
  onSelectEvent: PropTypes.func,
  onToggleCommonQs: PropTypes.func,
  onToggleAttireOs: PropTypes.func,
  onResetAddressSearch: PropTypes.func,
  forMultipleEventsMigration: PropTypes.bool,
  mealOptionCounts: PropTypes.shape({}),
  rsvpQuestionCounts: PropTypes.shape({}),
  onDeleteRsvpQuestion: PropTypes.func,
  onDeleteMealOption: PropTypes.func,
  onReorder: PropTypes.func,
};

export default EventForm;



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/EventForm.jsx